<template>
    <div id="contact-page">
        <!--================ About History Area  =================-->
        <section class="about_history_area section_gap append_gap">
            <div class="container">
                <div class="row">
                    <div class="col-md-6 d_flex align-items-center">
                        <div class="about_content " style="width:100%">
                            <h2 class="title title_color">訂房前須知<br>&<br>住宿約定 <br></h2>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <img class="img-fluid" src="../assets/news/bed-bedroom-bedsheet-2387753.jpg" alt="img">
                    </div>
                </div>
                <div class="row about_travel_intro">
                    <div class="col-md-12 d_flex align-items-center">
                        <div class="about_content ">
                            <h2 class="title title_color"></h2>
                            <p><small> + 想來度假嗎，相信您是個好旅人對吧</small></p>
                        </div>
                    </div>
                </div>

                <div class="contact-way">
                    <div class="contact-way-area row justify-content-around">
                        <div class="way-by-public contact-way-type col-md-10">
                            <div class="way-name">入住退房時間</div>
                            <div class="short-border"></div>
                            <div class="way-detail">
                                <div>CHECKIN- 入住</div>
                                <h3>3:00pm – 9:00pm</h3> <br/>
                                <small>●</small> 管家服務時間為8:00am – 10:00pm，為確保您入住後房務方面之服務，敬請於9:00pm前辦理入住<br/>
                                <small>●</small> 預訂房間保留至9:00pm，若因行程安排會晚於9:00pm以後入住者，請務必提前告知，以便為您保留房間並等待您入住<br/>
                                <small>●</small> 提前告知逾時入住，但若會超過10:00pm，將會另外酌收延遲抵達費; 超過午夜00:00，恕無法接待; 請務必自行控管時間與行程安排！<br/>
                                <small>●</small> 逾時且未提前告知，將視同入住，房間不予保留(或更改日期)，訂金不予退費<br/>
                            </div>
                            <div class="way-detail" style="margin-top: 50px;">
                                <div>CHECKOUT- 退房</div>
                                <h3>8:00am – 11:00am</h3> <br/>
                                <small>●</small> 民宿提供快速退房服務，如櫃檯無管家或其他人員，可直接將鑰匙投入櫃檯退房箱即可完成退房<br/>
                                <small>●</small> 退房時間為隔日11:00am，若臨時需延遲退房時間，請提早詢問，需視當日入住房況評估，並另酌收延長費用<br/>
                            </div>
                        </div>
                        <div class="way-by-public contact-way-type col-md-10">
                            <div class="way-name">管家服務時間</div>
                            <div class="short-border"></div>
                            <div class="way-detail">
                                <div>SERVICE- 服務與協助</div>
                                <h3>8:00pm – 10:00pm</h3> <br/>
                                <small>●</small> 管家服務時間為8:00am – 10:00pm<br/>
                                <small>●</small> 我們並非旅館或飯店，「無法提供 24小時服務」，而是分享一個恬靜的寓所，您可以自在的過一段台東生活。<br/>
                                <small>●</small> 在管家服務時間內，我們樂意並盡可能地為您提供住宿期間的詢問與幫忙，但也請您體諒無法保證每個臨時需求都能夠達成所願。<br/>
                                <small>●</small> 服務時間外，無法及時為您協助，不周之處，敬請見諒<br/>
                                <small>●</small> （若您對於非全天的管家服務有疑慮，再斟酌考量是否訂房）<br/>
                            </div>
                        </div>
                        <div class="way-by-private contact-way-type col-md-10">
                            <div class="way-name">訂房前須知</div>
                            <div class="short-border"></div>
                            <div class="way-detail" style="padding:36px 36px 50px 36px;">
                                <div>既然選擇了民宿，就別再以住飯店的角度或是指令式態度來對待這裡的人事物！<br/>我們初衷是希望「分享自己的生活空間與風格」，因為，這片土地這麼美，這裡景色讓人多麽著迷啊！
                                <br/>這裡，是由我們家人與幾位管家負責清掃、訂房、接待與準備早餐等服務，請您理解我們與管家們都不是被專業訓練過的飯店服務業，無法做到無微不至與以客為尊的貴賓接待; 
                                <br>身為台東在地人的我們，天生比較隨性樂活，都很誠摯歡迎您的到訪，並樂意為您提供住宿期間的詢問與幫忙，也期待每位到訪的旅客能在這隨遇而安！由衷謝謝您。</div>
                                <div></div>

                                
                            </div>
                            <div class="way-detail">
                                <div>入住環境須知</div>
                                <ul>
                                    <li>由於所在位置偏山區，無法完全避免<span class="hint-color">趨光性昆蟲、蚊蟲、壁虎或蜘蛛(喇牙)</span>出現。我們在做房務清潔時都會特別留意! 但若有疑慮或無法接受之旅人，請您絕對要酌量考量是否訂房。</li>
                                    <li>夏季蚊蟲較多，請住宿房客隨手關紗窗，以免蚊蟲打擾您的住宿品質。</li>
                                    <li>大廳及早餐餐廳會備有防蚊液讓旅客使用，客房內也都備有防蚊裝置供旅客開關使用。</li>
                                    <li>大自然蟲鳴鳥叫也是我們的特色哦，若無法接受青蛙、小鳥、蟬、蟋蟀等大自然動物及昆蟲的叫聲(像是早上叫你起床)，請您酌量考量是否訂房。</li> 
                                    <li>我們非經營寵物民宿，僅開放三間特定房間允許寵物入內，請勿未經詢問自行攜帶寵物入住。</li>
                                    <li>外表嚇人但[有百利而無一害]的喇牙: 本身沒有毒性，牠們生性比誰都膽小，最怕的也是人類，還會幫忙補食大家最討厭的蚊子、蟑螂哦！(在管家服務時間內，若有看到害怕，也是可以請管家為您協助處理！)</li>
                                </ul>
                            </div>
                            <div class="way-detail">
                                <div>加床加人規定</div>
                                <ul>
                                    <li>為維護客戶權益，請依房型人數住宿，超出人數可加床(視房型)，<span class="hint-color">可加床之房型，如下規定：</span></li>
                                    <li>
                                    <span class="hint-color">可加床房型 |</span><br/>
                                    VIP海景四人房 & VIP山海景六人房 & VIP精緻六人房
                                    </li>
                                    <li>
                                    <span class="hint-color">加床加人規定 |</span><br/>
                                    若入住超過房型人數，
                                    6歲以下之幼童，可免費與大人一同入住(免費同住，最多2位)；<br/>
                                    6歲以上、11歲以下孩童，需以加人或加床(＊視房型規定)方式付費入住；<br/>
                                    超過11歲（或成人），則視為占床入住，若超過房型人數，依各房型加床規定，須額外付費加床(＊視房型規定)入住。<br/>
                                    
                                    
                                    免費同住 | 不另供早餐與床品、備品。<br/>
                                    加人$500 | 含早餐一客，一人份備品(含毛浴巾，不含床被枕)<br/>
                                    加床$850 | 含早餐一客，一人份備品(含毛浴巾)及單人厚床墊(含單人被與枕)<br/>
                                    </li>
                                </ul>
                            </div>
                            <div class="way-detail">
                                <div>住宿約定</div>
                                <ul>
                                    <li>為維護每位房客的住房品質，<span class="hint-color">請勿在房間內(包含陽台)抽菸、吸毒、嚼檳榔及烹煮食物(包含生火、電磁爐、微波爐、瓦斯爐等)，若要抽菸，請至戶外庭院。</span></li> 
                                    
                                    <li>每日晚間10點至11點，大廳將熄燈留下夜燈，並做門禁管制，進出請攜帶感應磁扣。若需要使用大廳空間請降低音量避免喧嘩，以免打擾其他房客及鄰居休息。</li>
                                    <li><span class="hint-color">每日清晨7點前及晚間10點後，請降低音量</span>，以免打擾其他房客及鄰居休息。煩請家長協助孩童，勿於室內走廊梯間嬉鬧、 蹦跳、奔跑，以免導致碰撞受傷或影響其他房客。</li>
                                    <li>民宿禁止打麻將、賭博與喧嘩唱歌等任何音量過大會影響其他房客之活動，若無法遵守此項規定，且屢勸不聽，我們將立刻請您退房，恕不退費。</li>
                                    <li>嚴禁吸食違禁藥品及音樂派對(轟趴)，違反一律報警處理，並立即要求退房及賠償。</li>
                                    
                                    <li>除室內提供之拋棄式盥洗用具外，其他物品請勿帶走。如: 衣架、毛浴巾、吹風機、快煮壺、杯子、備品盒、體重計等，若想購買請洽詢櫃檯。並請愛護民宿中一切設備，如有損壞，依照市價賠償。 </li>
                                    <li>我們是很愛寵物的主人，但請體諒部分房客會對寵物過敏，請勿攜帶寵物入屋內。</li>
                                    <li>這裡是有合法經營模式的住宿空間(例如：消防、保險等)，相對的也給您一個安全放心的居所，所以入住Check-in時，請出示您的國民身分證，以便我們辦理登記，並請將您的住宿費用繳清。 </li>
                                    <li>離開房間時，請隨手將房間鎖上，貴重物品請自行小心保管，若有遺失恕不負責；外出時可將鑰匙寄放櫃檯，以免鑰匙遊玩時遺失；退房時，請務必繳回房門鑰匙。 </li>
                                    <li>請確實做好資源回收以愛護我們的地球。</li>
                                    <li>住宿皆投保公共意外責任保險。</li>
                                </ul>
                            </div>
                        </div>
                        <div class="way-by-public contact-way-type col-md-10">
                            <div class="way-name">餐點提供時間</div>
                            <div class="short-border"></div>
                            <div class="way-detail">
                                <div>BREAKFAST- 早餐</div>
                                <h3>7:30am – 9:50am </h3><br/>
                                 <small>●</small> 座位有限，採分時段用餐制，於辦理入住時登記，最遲於入住當日21:00前登記; 如未即時登記將視為放棄用餐<br/>
                                 <small>●</small> 超過用餐供應時間未用餐，將視為放棄用餐<br/>
                                 <small>●</small> 住宿皆附套餐式早餐(不分大人/小孩)，根據<span class="hint-color">住宿房型之人數</span>供餐，免費同住孩童不另外提供小孩餐點，請房客依房間人數入座用餐<br/>
                                 <small>●</small> <span class="hint-color">官網線上訂房之LongStay長住優惠專案不含早餐</span>, 於網路預訂時請務必確認清楚方案內容<br/>
                                 <small>●</small> <span class="hint-color">部分OTA訂房專案不含早餐</span>, 如Agoda, 於網路預訂時請務必確認清楚方案內容<br/>
                                 <small>●</small> 如有以下特殊需求，請盡早與我們告知，以便替您準備:（最遲請於入住當日18:00前提前告知）<br/>
                                如需額外加購早餐/ 若有特殊飲食需求/ 若因行程安排需提前用餐
                            </div>
                            <div class="way-detail">
                                <div>OTHERS- 其他時段無供應餐點</div>
                                <small>●</small> 民宿商品展示區有販賣泡麵,零食與啤酒等（依現場實際供應內容為主）<br/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!--================ About History Area  =================-->
    </div>
</template>

<script>

export default {
  name: 'contact',
  components: {}
}
</script>
<style lang="scss">
$contact-info-color: #2f2f2f;
.hint-color {
    color: brown;
}
.about_contact_info {
    max-width: 300px;
    margin: auto;
    text-align: left;
}
.about_travel_intro {
    text-align: left;
    border-top: 2px solid;
    margin-top: 20px;
}
#contact-page {
    .contact-way {
        padding: 5rem 16px;
        background: rgba(0, 0, 0, 0.1);
        position: relative;
        // &:before {
        //     content: '';
        //     position: absolute;
        //     top: 0;
        //     /* border-bottom: 25px rgba(0, 0, 0, 0.1) solid; */
        //     border-right: 25px rgba(0, 0, 0, 0.1);
        //     border-left: 25px rgba(0, 0, 0, 0.1) solid;
        //     border-top: 25px solid white;
        //     left: 50%;
        //     margin-left: -25px;
        // }
        .title {
            font-size: 32px;
            font-weight: 100;
            color: #000;
            // margin-bottom: 5rem;
        }
        .contact-way-area .contact-way-type {
            .way-name {
                color: #FF6161;
                font-size: 18px;
                text-align: center;
                transition: 1s ease;
            }
            .way-detail {
                margin-top: 10px;
                & > div {
                    font-weight: 600;
                }
            }
            .short-border {
                width: 4rem;
                height: 1px;
                background: #FF6161;
                margin: .5rem auto 2rem auto;
            }
            // padding: 5rem 4.5rem;
            // background: rgba(4, 81, 132, 1);
            // color: white;
            // font-weight: 100;
            letter-spacing: 1px;
            text-align: left;
            transition: 1s ease;
            margin-bottom: 60px;
            // &:hover {
            //     background: #000;
            //     .way-name {
            //         font-size: 32px;
            //     }
            // }
        }
        .contact-way-direction {
            img {
                width: 80%;
                max-width: 600px;
            }
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/components/Preknow.vue